/* =========================================================
   ByMeeru — theme.js
   Vanilla JS only, no dependencies.
   ========================================================= */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Mobile nav drawer ---------- */
  var mobileNav = qs('[data-mobile-nav]');
  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  qsa('[data-mobile-nav-open]').forEach(function (btn) { btn.addEventListener('click', openMobileNav); });
  qsa('[data-mobile-nav-close]').forEach(function (btn) { btn.addEventListener('click', closeMobileNav); });

  /* ---------- Search overlay ---------- */
  var searchOverlay = qs('[data-search-overlay]');
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    var input = qs('input[type="search"]', searchOverlay);
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }
  qsa('[data-search-open]').forEach(function (btn) { btn.addEventListener('click', openSearch); });
  qsa('[data-search-close]').forEach(function (btn) { btn.addEventListener('click', closeSearch); });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = qs('#CartDrawer');
  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  qsa('[data-cart-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  });
  /* Delegated so close buttons inside re-rendered drawer content keep working */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  });

  function updateCartCountBubbles(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* Standard Ajax Cart API calls (throw on failure so the UI can show it) */
  function requestJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) { throw new Error(data.description || data.message || 'Cart request failed'); }
        return data;
      });
    });
  }
  function addToCart(id, quantity) {
    var variantId = String(id == null ? '' : id).trim();
    var qty = Math.max(1, parseInt(quantity, 10) || 1);

    /* Shopify requires the PRODUCT VARIANT ID for cart/add.js. */
    if (!variantId || !/^[0-9]+$/.test(variantId)) {
      return Promise.reject(new Error('Missing or invalid product variant.'));
    }

    var root =
      window.Shopify &&
      window.Shopify.routes &&
      typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';

    if (root.charAt(root.length - 1) !== '/') root += '/';

    var payload = { items: [{ id: variantId, quantity: qty }] };

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = {};
        try { data = text ? JSON.parse(text) : {}; } catch (err) { data = {}; }

        if (res.ok) return data;

        /* Fallback using Shopify's standard product-form payload. */
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', String(qty));

        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: formData
        }).then(function (fallbackRes) {
          return fallbackRes.text().then(function (fallbackText) {
            var fallbackData = {};
            try { fallbackData = fallbackText ? JSON.parse(fallbackText) : {}; } catch (err2) { fallbackData = {}; }

            if (!fallbackRes.ok) {
              throw new Error(
                fallbackData.description ||
                fallbackData.message ||
                data.description ||
                data.message ||
                'Unable to add this product to the cart.'
              );
            }

            return fallbackData;
          });
        });
      });
    });
  }

  function changeCartLine(line, quantity) {
    return requestJson('/cart/change.js', { line: line, quantity: quantity });
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); });
  }

  function refreshCartDrawer() {
    return fetch('/cart', { cache: 'no-store', headers: { 'Accept': 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBody = doc.querySelector('[data-cart-drawer-body]');
        var newFooter = doc.querySelector('.cart-drawer__footer');
        var newTitle = doc.querySelector('.cart-drawer__header h2');
        var body = qs('[data-cart-drawer-body]');
        var title = qs('.cart-drawer__header h2');
        var oldFooter = qs('.cart-drawer__footer');

        if (newBody && body) body.innerHTML = newBody.innerHTML;
        if (newTitle && title) title.innerHTML = newTitle.innerHTML;

        if (newFooter && oldFooter) oldFooter.outerHTML = newFooter.outerHTML;
        else if (newFooter && !oldFooter && cartDrawer) qs('.cart-drawer__panel', cartDrawer).insertAdjacentHTML('beforeend', newFooter.outerHTML);
        else if (!newFooter && oldFooter) oldFooter.remove();

        bindCartDrawerEvents();
      })
      .catch(function () { /* drawer keeps its last state if the refresh fails */ });
  }

  function syncCart() {
    return fetchCart().then(function (c) { updateCartCountBubbles(c.item_count); return refreshCartDrawer(); });
  }

  /* Drawer line controls — scoped to the drawer only (the cart page has its own handlers) */
  function bindCartDrawerEvents() {
    qsa('#CartDrawer [data-cart-item]').forEach(function (item) {
      var line = parseInt(item.getAttribute('data-line'), 10);
      var decrease = qs('[data-quantity-decrease]', item);
      var increase = qs('[data-quantity-increase]', item);
      var valueEl = qs('[data-quantity-value]', item);
      var removeBtn = qs('[data-cart-remove]', item);
      var current = function () { return parseInt(valueEl.textContent, 10) || 1; };

      if (decrease) decrease.addEventListener('click', function () {
        changeCartLine(line, Math.max(0, current() - 1)).then(syncCart).catch(syncCart);
      });
      if (increase) increase.addEventListener('click', function () {
        changeCartLine(line, current() + 1).then(syncCart).catch(syncCart);
      });
      if (removeBtn) removeBtn.addEventListener('click', function () {
        changeCartLine(line, 0).then(syncCart).catch(syncCart);
      });
    });
  }
  bindCartDrawerEvents();

  /* ---------- Cart page quantity/remove ---------- */
  qsa('.cart-table [data-cart-item]').forEach(function (item) {
    var line = parseInt(item.getAttribute('data-line'), 10);
    var decrease = qs('[data-quantity-decrease]', item);
    var increase = qs('[data-quantity-increase]', item);
    var valueEl = qs('[data-quantity-value]', item);
    var removeBtn = qs('[data-cart-remove]', item);
    function apply(qty) {
      changeCartLine(line, qty).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
    }
    if (decrease) decrease.addEventListener('click', function () { apply(Math.max(0, (parseInt(valueEl.value, 10) || 1) - 1)); });
    if (increase) increase.addEventListener('click', function () { apply((parseInt(valueEl.value, 10) || 0) + 1); });
    if (removeBtn) removeBtn.addEventListener('click', function () { apply(0); });
  });

  /* ---------- Product / card Buy Now ---------- */
  /*
     Use native Shopify product forms for purchases. In the theme editor,
     return to the cart instead of /checkout because checkout cannot be
     rendered inside the theme-editor preview iframe.
  */
  qsa('[data-product-form]').forEach(function (formWrap) {
    var form = qs('form', formWrap);
    var buyNow = qs('[data-buy-now]', formWrap);
    if (!form || !buyNow) return;

    buyNow.addEventListener('click', function (e) {
      e.preventDefault();

      var hiddenReturn = qs('input[name="return_to"]', form);
      if (!hiddenReturn) {
        hiddenReturn = document.createElement('input');
        hiddenReturn.type = 'hidden';
        hiddenReturn.name = 'return_to';
        form.appendChild(hiddenReturn);
      }

      hiddenReturn.value =
        (window.Shopify && window.Shopify.designMode) ? '/cart' : '/checkout';

      buyNow.disabled = true;
      buyNow.textContent = 'Adding…';

      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  });

  /* ---------- Sticky mobile add-to-cart ---------- */
  var stickyAtc = qs('[data-sticky-atc]');
  var mainAddBtn = qs('[data-add-to-cart]');
  if (stickyAtc && mainAddBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAddBtn);

    var stickyBtn = qs('[data-sticky-atc-button]', stickyAtc);
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var mainForm = qs('[data-product-form] form');
      if (mainForm) { if (mainForm.requestSubmit) mainForm.requestSubmit(); else mainForm.dispatchEvent(new Event('submit', { cancelable: true })); }
    });
  }

  /* ---------- Size guide modal ---------- */
  var sizeGuideModal = qs('[data-size-guide-modal]');
  qsa('[data-size-guide-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (sizeGuideModal) { sizeGuideModal.classList.add('is-open'); sizeGuideModal.setAttribute('aria-hidden', 'false'); }
    });
  });
  qsa('[data-size-guide-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (sizeGuideModal) { sizeGuideModal.classList.remove('is-open'); sizeGuideModal.setAttribute('aria-hidden', 'true'); }
    });
  });

  /* ---------- Collection filter panel (mobile) ---------- */
  var filterPanel = qs('[data-filter-panel]');
  qsa('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!filterPanel) return;
      var isOpen = filterPanel.classList.toggle('is-open');
      filterPanel.setAttribute('aria-hidden', String(!isOpen));
    });
  });

  var sortSelect = qs('[data-sort-select]');
  if (sortSelect) sortSelect.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var WISHLIST_KEY = 'bymeeru_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (err) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (err) { /* storage unavailable */ }
  }
  function isWishlisted(id) {
    return getWishlist().some(function (item) { return String(item.id) === String(id); });
  }
  function toggleWishlist(id, data) {
    var list = getWishlist();
    var idx = list.findIndex(function (item) { return String(item.id) === String(id); });
    if (idx > -1) { list.splice(idx, 1); }
    else { list.push(Object.assign({ id: id }, data || {})); }
    saveWishlist(list);
    updateWishlistCount();
    return idx === -1;
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    qsa('[data-wishlist-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }
  function refreshWishlistButtons() {
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.setAttribute('aria-pressed', String(isWishlisted(id)));
    });
  }
  qsa('[data-wishlist-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-product-id');
      var card = btn.closest('[data-product-card]');
      var data = {};
      if (card) {
        var titleEl = qs('.product-card__title a', card);
        var imgEl = qs('.product-card__img--primary', card);
        var linkEl = qs('.product-card__media', card);
        data = {
          title: titleEl ? titleEl.textContent.trim() : '',
          url: linkEl ? linkEl.getAttribute('href') : '',
          image: imgEl ? imgEl.getAttribute('src') : ''
        };
      }
      var nowActive = toggleWishlist(id, data);
      btn.setAttribute('aria-pressed', String(nowActive));
    });
  });
  updateWishlistCount();
  refreshWishlistButtons();

  var wishlistGrid = qs('[data-wishlist-grid]');
  var wishlistEmpty = qs('[data-wishlist-empty]');
  if (wishlistGrid) {
    var items = getWishlist();
    if (items.length === 0) {
      wishlistGrid.hidden = true;
      if (wishlistEmpty) wishlistEmpty.hidden = false;
    } else {
      wishlistGrid.innerHTML = items.map(function (item) {
        return (
          '<div class="product-card">' +
            '<a href="' + (item.url || '#') + '" class="product-card__media">' +
              '<img class="product-card__img product-card__img--primary" src="' + (item.image || '') + '" alt="' + (item.title || '') + '" loading="lazy">' +
            '</a>' +
            '<div class="product-card__info">' +
              '<h3 class="product-card__title"><a href="' + (item.url || '#') + '">' + (item.title || '') + '</a></h3>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
  }

  /* ---------- Announcement bar rotation ---------- */
  var track = qs('[data-announcement-track]');
  if (track && track.children.length > 1) {
    var idx = 0;
    setInterval(function () {
      idx = (idx + 1) % track.children.length;
      track.style.transform = 'translateY(-' + (idx * 100) + '%)';
    }, 4000);
    track.style.transition = 'transform .4s ease';
  }

  /* ---------- Close overlays on Escape ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMobileNav();
    closeSearch();
    closeCartDrawer();
    if (sizeGuideModal) { sizeGuideModal.classList.remove('is-open'); sizeGuideModal.setAttribute('aria-hidden', 'true'); }
  });
})();
